// Module
var code = "<div class=\"params-typeahead-result clearfix\"> <div class=\"clearfix row\"> <div class=\"col-xs-12\"> <div>No recently used parameters found.</div> </div> </div> </div> ";
// Exports
module.exports = code;